"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SpecialPermit = void 0;
const Card_1 = require("../Card");
const CardName_1 = require("../../CardName");
const CardType_1 = require("../CardType");
const CardRenderer_1 = require("../render/CardRenderer");
const Resources_1 = require("../../Resources");
const CardRequirements_1 = require("../CardRequirements");
const PartyName_1 = require("../../turmoil/parties/PartyName");
const constants_1 = require("../../constants");
const Tags_1 = require("../Tags");
const Size_1 = require("../render/Size");
const MonsInsuranceBot_1 = require("../automa/MonsInsuranceBot");
const OrOptions_1 = require("../../inputs/OrOptions");
const SelectOption_1 = require("../../inputs/SelectOption");
class SpecialPermit extends Card_1.Card {
    constructor() {
        super({
            cardType: CardType_1.CardType.EVENT,
            name: CardName_1.CardName.SPECIAL_PERMIT,
            tags: [Tags_1.Tags.PLANT],
            cost: 5,
            requirements: CardRequirements_1.CardRequirements.builder((b) => b.party(PartyName_1.PartyName.GREENS)),
            metadata: {
                cardNumber: 'P82',
                description: 'Requires that Greens are ruling or that you have 2 delegates there. Steal 4 plants from any player.',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.br;
                    b.text('steal', Size_1.Size.MEDIUM, true).plants(4).any;
                }),
            },
        });
    }
    canPlay(player) {
        const turmoil = player.game.turmoil;
        if (turmoil !== undefined) {
            if (turmoil.parties.find((p) => p.name === PartyName_1.PartyName.GREENS)) {
                return turmoil.canPlay(player, PartyName_1.PartyName.GREENS);
            }
            return player.canAfford(player.getCardCost(this) + constants_1.SOCIETY_ADDITIONAL_CARD_COST);
        }
        return false;
    }
    play(player) {
        var _a;
        if (player.game.isSoloMode()) {
            if (((_a = player.game.automaBotCorporation) === null || _a === void 0 ? void 0 : _a.name) === CardName_1.CardName.MONS_INSURANCE_BOT) {
                MonsInsuranceBot_1.MonsInsuranceBot.resolveMonsInsuranceBot(player);
            }
            player.addResource(Resources_1.Resources.PLANTS, 2);
            return undefined;
        }
        const availablePlayerTargets = player.game.getPlayers().filter((p) => p.id !== player.id);
        const availableActions = new OrOptions_1.OrOptions();
        availablePlayerTargets.forEach((target) => {
            if (target.plants > 0 && !target.plantsAreProtected()) {
                const amountStolen = Math.min(4, target.plants);
                const optionTitle = 'Steal ' + amountStolen + ' plants from ' + target.name;
                availableActions.options.push(new SelectOption_1.SelectOption(optionTitle, 'Confirm', () => {
                    player.addResource(Resources_1.Resources.PLANTS, amountStolen);
                    target.deductResource(Resources_1.Resources.PLANTS, amountStolen, { log: true, from: player });
                    return undefined;
                }));
            }
        });
        if (availableActions.options.length > 0) {
            availableActions.options.push(new SelectOption_1.SelectOption('Do not steal', 'Confirm', () => {
                return undefined;
            }));
            return availableActions;
        }
        return undefined;
    }
}
exports.SpecialPermit = SpecialPermit;
//# sourceMappingURL=SpecialPermit.js.map